import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    SET_INSPECTION_RESPONSE
    SET_AUCTION_RESPONSE
    SET_CAR_DETAILS_RESPONSE
    SET_PAGE_LOADING
    SET_ERROR_STATUS
    SET_INSPECTION_DATE
    SET_INSPECTION_TIME
    SET_PRICE_BREAKUP
    SET_CJ_DETAIL
    SET_VIRTUAL_DETAILS
    GET_PURCHASE_TOKEN
    SET_BANK_VERIFICATION_DATA
    SET_DOCUMENT_DATA
    SET_REQUIRED_DOCUMENTS_LIST
    SET_DMS_LOGIN_DATA
    SET_PICKUP_DETAIL
    SET_PICKUP_SLOT
    SET_CAMPAGIN_PRICE
    GET_PICKUP_DOCUMENTS
    SET_COMPLETED_STEP_LIST
    SET_POST_TOKEN_DOCUMENTS
    SET_CURRENT_GA_EVENT_DETAILS
    SET_NOC_AVAILABILITY
    SET_DIY_DETAILS
    SET_KMS_DRIVEN
    SET_SCREEN_DETAILS
    SET_ACTIVE_TAB
    SET_DIY_INTENT
    SET_PRICE_DISCOVERY
    SET_PRICE_BREAKUP
    SET_SELF_NEGO_DETAILS
    SET_HAMMER_SWIPE
    SET_LOAN_DETAIL
    SET_CAR_HANDOVER_DETAILS
    SET_UPDATED_IMPRESSIONS
    SET_SECONDARY_PHONE
    SET_IS_FETCHED
    SET_DNP_OFFER
    SET_CAR_HEALTH
    RESET_CAR_HEALTH
`,
    {
        prefix: "postinspectiondiy/"
    }
);
